"use client";

import Button from "@/components/ui/Button";

interface ScrollToAnchorLinkProps {
  children: React.ReactNode;
  buttonProps?: React.ComponentProps<typeof Button>;
  elementId: string;
  className?: string;
}

export const ScrollToAnchorLink = ({ className, children, buttonProps, elementId }: ScrollToAnchorLinkProps) => {

  const handleClick = () => {
    const targetElement = document.getElementById(elementId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Button className={className} onClick={handleClick} {...buttonProps}>
      {children}
    </Button>
  );
};